import BaseModelAPI from '../BaseModelAPI';

export default class FinishGoodQcConfirmationList extends BaseModelAPI {

	static entity = 'newobject2326list'
	static entityName = 'finishgoodqcconfirmation';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
